/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/array/ArrayInsert.ts
 * @create:      2025-06-26 15:59:16.599
 * @modify:      2025-07-11 21:19:12.784
 * @version:     6.0.0
 * @times:       4
 * @lines:       57
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Inserts elements into an array at the specified index.
 *
 * @param array - The target array.
 * @param index - The index at which to insert the elements.
 * @param items - The elements to insert into the array.
 * @throws Throws an error if the index is out of bounds.
 * @returns The modified array.
 * 
 * @since 4.2.7
 * @version 2023-11-25
 */
export function ArrayInsert<T>(array: T[], index: number, ...items: T[]): T[] {
    // Validate index
    if (index < 0 || index > array.length) {
        throw new Error("Index is out of bounds");
    }

    // Splice the items into the array at the specified index
    array.splice(index, 0, ...items);

    // Return the modified array
    return array;
}
